import { render, staticRenderFns } from "./RfxManageResponsesNew.vue?vue&type=template&id=2985d7a0"
import script from "./RfxManageResponsesNew.vue?vue&type=script&lang=js"
export * from "./RfxManageResponsesNew.vue?vue&type=script&lang=js"
import style0 from "./RfxManageResponsesNew.vue?vue&type=style&index=0&id=2985d7a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports